import {app} from '../app';

class CompileDirective implements ng.IDirective {

    private compileService:ng.ICompileService;

    restrict = 'A';

    constructor($compile:ng.ICompileService) {
        this.compileService = $compile;
    }

    link(scope, element, attrs, ctrl) {
        let compilationScope:ng.IScope;

        const compile = (newHTML) => {
            if (compilationScope) {
                compilationScope.$destroy();
            }

            var content = this.compileService(newHTML)(compilationScope = scope.$new());
            element.html('').append(content);
        };

        scope.$watch(attrs.compile, (newHTML) => {
            if (!newHTML) {
                return;
            }

            compile(newHTML);
        });
    }

    static factory() {
        const _directive = ($compile:ng.ICompileService) => new this($compile);
        _directive.$inject = ['$compile'];
        return _directive;
    }

}

app.directive('compile', CompileDirective.factory());